import React from "react";
import ParagraphFile from "components/Paragraphs/ParagraphFile";
import ParagraphPosterFile from "components/Paragraphs/ParagraphPosterFile";

const DISPLAY_MODES = {
  DEFAULT: "default",
  POSTERS: "posters",
};

export default function ParagraphFiles({ data }) {
  const { field_display_mode: displayMode } = data;

  if (displayMode === DISPLAY_MODES.POSTERS) {
    return (
      <div className="w-full mx-auto lg:max-w-screen-lg">
        {data.field_title && (
          <h2 className="mb-8 font-important text-4xl">{data.field_title}</h2>
        )}

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {data.field_paragraphs.map((paragraph) => {
            return (
              <div key={paragraph.id}>
                <ParagraphPosterFile data={paragraph} />
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  return (
    <div className="w-full mx-auto lg:max-w-screen-lg">
      {data.field_title && (
        <h2 className="mb-8 font-important text-4xl">{data.field_title}</h2>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {data.field_paragraphs.map((paragraph) => {
          return (
            <div key={paragraph.id}>
              <ParagraphFile data={paragraph} />
            </div>
          );
        })}
      </div>
    </div>
  );
}
